/* eslint-disable */
import React, { Component } from 'react';
import { DataGridCustom } from '../../components/index';
import { formatarValor } from '../../utils/helpers';
import './DadosHistoricoPrescricao.css';

class DadosHistoricoPrescricao extends Component {
  obterPrescricao = () => {
    return this.props.estadoFormulario.requerimento.prescricao || {};
  }
  obterNumero = valor => {
    if (!valor) return 0;
    if (typeof valor === 'number')
        return valor;
    return Number(
        String(valor)
            .replace(/\./g, '')
            .replace(',', '.')
    );
  }

  renderCard = (titulo, valor, cor) => (
    <div className="prescricao-card">
        <div
            className="prescricao-card-faixa"
            style={{ background: cor }}
        />
        <div className="prescricao-card-titulo">
            {titulo}
        </div>
        <div className="prescricao-card-valor">
            {formatarValor(valor)}
        </div>
    </div>
  );

  renderDashboard = () => {
    const p = this.obterPrescricao();
    return (
        <DataGridCustom
            title="Resumo Financeiro da Prescrição"
            retirarLinhaSeparadora={false}
        >
          <div className="dashboard-prescricao">
            <div className="dashboard-total">
                <div className="dashboard-linha-titulo">
                    Valor Total Prescrito
                </div>
                <div className="dashboard-total-valor">
                    {formatarValor(p.vlTotalPrescricao)}
                </div>
            </div>
            <div className="dashboard-cards">
              {this.renderCard("Estoque",p.vlEstoquePrescricao,"#FF9800")}
              {this.renderCard("Fluxo",p.vlPassivoPrescricao,"#00A651")}
              {this.renderCard("Pró-rata",p.vlProRataPrescricao,"#1565C0")}
            </div>
          </div>
      </DataGridCustom>
    );
  }
  renderDetalhes = () => {
    const p = this.obterPrescricao();
    return (
        <DataGridCustom
            title="Detalhamento"
            retirarLinhaSeparadora={false}
        >
        <div className="detalhes-grid">
            <div className="detalhe-item detalhe-laranja">
              <span>Estoque</span>
              <strong>
                  {formatarValor(p.vlEstoquePrescricao)}
              </strong>
            </div>
            <div className="detalhe-item detalhe-verde">
              <span>Fluxo acumulado</span>
              <strong>{formatarValor(p.vlPassivoPrescricao)}
              </strong>
            </div>
            <div className="detalhe-item">
                <span>Valor total prescrito</span>
                <strong>
                    {formatarValor(p.vlTotalPrescricao)}
                </strong>
            </div>
            <div className="detalhe-item detalhe-laranja">
              <span>Início do estoque</span>
              <strong>
                  {p.dtIniPeriodoEstoquePrescricao}
              </strong>
            </div>
            <div className="detalhe-item detalhe-verde">
              <span>Início do fluxo</span>
              <strong>
                  {p.dtIniPeriodoPassivoPrescricao}
              </strong>
            </div>
            <div className="detalhe-item">
              <span>Pró-rata do 1º pagamento</span>
              <strong>
                  {formatarValor(p.vlProRataPrescricao)}
              </strong>
            </div>
            <div className="detalhe-item detalhe-laranja">
              <span>Fim do estoque</span>
              <strong>
                  {p.dtFimPeriodoEstoquePrescricao}
              </strong>
            </div>
            <div className="detalhe-item detalhe-verde">
              <span>Fim do fluxo</span>
              <strong>
                  {p.dtFimPeriodoPassivoPrescricao}
              </strong>
            </div>
            <div className="detalhe-item detalhe-vermelho">
              <span>Quantidade de dias prescritos</span>
              <strong>
                  {p.qtdeDiasPrescritos}
              </strong>
            </div>
            <div className="detalhe-item detalhe-laranja">
              <span>13º do estoque</span>
              <strong>
                  {formatarValor(p.vl13EstoquePrescricao)}
              </strong>
            </div>
            <div className="detalhe-item detalhe-verde">
              <span>13º do fluxo</span>
              <strong>
                  {formatarValor(p.vl13PassivoPrescricao)}
              </strong>
            </div>
          </div>
          {/* LEGENDA */}
          <div style={{ marginTop: 20, display: 'flex', gap: 20 }}>
            {[
              { c: '#FF9800', l: 'Estoque' },
              { c: '#00A651', l: 'Fluxo' },
              { c: '#1565C0', l: 'Prescrição' },
            ].map(leg => (
              <div key={leg.l} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 12, height: 12, background: leg.c }} />
                <span style={{ fontSize: 12 }}>{leg.l}</span>
              </div>
            ))}
          </div>
        </DataGridCustom>
      );
    }
    render() {
      return (
        <React.Fragment>
            {this.renderDashboard()}
            {this.renderDetalhes()}
        </React.Fragment>
      );
    }
}

export default DadosHistoricoPrescricao;

// /* eslint-disable */
// import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { Title, Grid, SimpleGrid, DataGridCustom } from '../../components/index';
// import { formatarValor, formatarCnpj } from '../../utils/helpers';

// /* Grid, Input, Modal, Title */
// class DadosHistoricoPrescricao extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       // prescricoes: [],
//     };
//   }

//   formatarMoeda = (valor) => {
//     if (valor == null) return '0,00';
//     const numero = typeof valor === 'string'
//       ? parseFloat(valor.replace(/\./g, '').replace(',', '.'))
//       : Number(valor);
//     if (Number.isNaN(numero)) return '0,00';
//     return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   }

//   textoDestaque = texto => (
//     (<span style={{ fontWeight: '600' }}>{texto}</span>)
//   )

//   montaDadosPrescricao = () => {
//     const rowStyle = { marginBottom: '10px', fontSize: '16px' };
//     return (
//       <React.Fragment>
//         <DataGridCustom title="Prescrição" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Pró-rata no 1º pagamento: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlProRataPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Valor Total Prescrito: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlTotalPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Qtde de Dias Prescritos: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.qtdeDiasPrescritos}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//         <DataGridCustom title="Estoque" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Estoque: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlEstoquePrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('13º de estoque: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vl13EstoquePrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Início da prescrição do estoque: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoEstoquePrescricao}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fim da prescrição do estoque: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoEstoquePrescricao}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//         <DataGridCustom title="Fluxo" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fluxo acumulado: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlPassivoPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('13º de fluxo acumulado: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vl13PassivoPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Início da prescrição do fluxo: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoPassivoPrescricao}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fim da prescrição do fluxo: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoPassivoPrescricao}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//       </React.Fragment>
//     );
//   }

//   render() {
//     return (
//       <React.Fragment>
//         {this.montaDadosPrescricao()}
//       </React.Fragment>
//     );
//   }
// }

// export default DadosHistoricoPrescricao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/DadosHistoricoPrescricao.jsx